import React from 'react';
import { FeatureList } from 'components/core/FeatureList';
import moveInUnit from '../../../assets/images/icons/move-in-unit.svg';
import searchProperty from '../../../assets/images/icons/search-property.svg';
import reserveForFree from '../../../assets/images/icons/reserve-for-free.svg';
import { H2, H3, Paragraph } from 'components/core/Typography';
import { Container } from 'components/core/Page';
import { Card } from 'components/core/Card';
import locationIcon from 'assets/images/psp/FindStorageNearYou/Address.svg';

import './HowItWorksV2.scss';

export const howItWorksFeatures = [
	{
		title: 'Select your storage unit',
		icon: searchProperty,
	},
	{
		title: 'Reserve for free',
		description: 'Cancel or change your reservation at any time, risk-free',
		icon: reserveForFree,
	},
	{
		title: 'Visit your facility',
		icon: locationIcon,
	},
	{
		title: 'Move in!',
		icon: moveInUnit,
	},
];

export default function HowItWorksFeatures() {
	return (
		<div className="how-it-works">
			<Container className="how-it-works__container">
				<div className='how-it-works__content'>
					<Paragraph
						strong
						className="omi-section-heading how-it-works__heading"
					>
						Rent online today or make a <br className="break" />{' '}
						risk-free reservation
					</Paragraph>
					<div className="omi-section">
						<Paragraph className="how-it-works__paragraph">
							There's two easy ways to secure a unit at this
							storage facility:
						</Paragraph>
						<ol
							type="1"
							className="how-it-works__list"
						>
							<li
								value="1"
								className="how-it-works__list-item"
							>
								<span className="how-it-works__list-value">
									1
								</span>
								<span className="how-it-works__list-content">
									You can complete your rental process online
									today and go straight to your unit when you
									plan to move in.
								</span>
							</li>
							<li
								value="2"
								className="how-it-works__list-item"
							>
								<span className="how-it-works__list-value">
									2
								</span>
								<span className="how-it-works__list-content">
									You can make a reservation today with no
									payment until you sign your lease at your
									move-in date.
								</span>
							</li>
						</ol>
					</div>
				</div>
				<Card className="how-it-works__card">
					<H2
						size="medium"
						className="how-it-works__title"
					>
						How It Works
					</H2>
					<FeatureList features={howItWorksFeatures} />
				</Card>
			</Container>
		</div>
	);
}
